import type { ThemeConfig } from 'antd';

/**
 * Phase 0 antd theme — colour + fonts only.
 * Full 39-token system deferred to PLAN.md Phase 8. Do not add token overrides
 * during feature work; batch them into the design phase.
 */
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#2f6ab0',
    fontFamily: "'Instrument Sans', system-ui, -apple-system, sans-serif",
  },
};
